import request from '@/utils/request';

// 카테고리 목록 조회
export function getCategoryList(data) {
	return request({
		url: '/v2/category/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});
}

export function getCategoryTop10(data) {
	return request({
		url: '/v2/category/listTop',
		method: 'post',
		data,
	});
}

// 브랜드 목록 조회
export function getBrandList(data) {
	return request({
		url: '/brand/list',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data,
	});

	/*
  return new Promise(function (resolve, reject) {
    resolve(brandMockupData)
  })
  */
}
